import Vue from "vue";
import Router from "vue-router";

import public_routes from "./public"
import mesh_routes from "./mesh"
import teaching_routes from "./teaching"
import evaluation_routes from "./evaluations"
import new_evaluation_routes from "./new_evaluation"
import report_routes from "./reports"
import assessments_routes from "./assessments"

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/register',
            name: 'Register',
            component: () =>
                import("@/components/users/Register"),
        },
        {
            path: '/profile',
            name: 'Profile',
            component: () =>
                import("@/components/users/Profile"),
        },
        {
            path: '/students/',
            name: 'StudentListView',
            component: () =>
                import("@/components/users/StudentListView"),
        },
        {
            path: '/admin-institution',
            name: 'AdminInstitutionView',
            component: () =>
                import("@/components/users/AdminInstitutionView"),
        },
        {
            path: '/admin-user',
            name: 'AdminUsersView',
            component: () =>
                import("@/components/users/AdminUsersView"),
        },
        {
            path: '/evaluation/achievements/',
            name: 'AchievementsPerCompetenceView',
            component: () =>
                import("@/components/dashboard/AchievementsPerCompetence/AchievementsPerCompetenceView"),
        },
        {
            path: '/session-planning/:egress_profile_matter_id/:section_id/',
            name: 'SessionPlanningView',
            component: () =>
                import("@/components/dashboard/SessionPlanning/SessionPlanningView"),
        },
        {
            path: '/acts/form/',
            name: 'ActsView',
            component: () =>
                import("@/components/acts/ActView"),
        },
        {
            path: '/admission/form/',
            name: 'AdmissionProfileView',
            component: () =>
                import("@/components/cideu/AdmissionProfileView"),
        },
        {
            path: '/user/form/',
            name: 'UseCardView',
            component: () =>
                import("@/components/cideu/UseCard/UseCardView"),
        },
        {
            path: '/home/',
            name: 'DashboardView',
            component: () =>
                import("@/components/public/DashboardView"),
        },
        ...public_routes,
        ...mesh_routes,
        ...teaching_routes,
        ...evaluation_routes,
        ...new_evaluation_routes,
        ...report_routes,
        ...assessments_routes,
    ],
    scrollBehavior(to, from) {
        // No hacer scroll si solo cambiaron los query params (misma ruta)
        if (to.path === from.path) {
            return;
        }
        return { x: 0, y: 0, behavior: 'smooth' };
    },
    mode: 'history'
});